/* Served enhancements: homepage card tags, 'served on you' camera, product tags + size guide buttons */
(function () {
  const cards = () => document.querySelectorAll('.srv-card').forEach((card) => {
    if (card.dataset.tagged) return; card.dataset.tagged = '1';
    const media = card.querySelector('.srv-card__media');
    if (!media) return;
    const isSet = card.classList.contains('srv-card--set');
    const btns = [...card.querySelectorAll('.srv-quick__sizes > .srv-size, .srv-set-row:first-of-type .srv-size')];
    const sizes = [...new Set(btns.filter((b) => !b.disabled).map((b) => b.textContent.trim()))];
    if (sizes.length) {
      const pill = document.createElement('span');
      pill.className = 'srv-sizepill';
      pill.textContent = sizes.join(' · ');
      media.appendChild(pill);
    }
    if (card.dataset.type === 'skirt') {
      const b = document.createElement('span');
      b.className = 'srv-badge srv-badge--skort';
      b.textContent = 'Skort inside';
      const best = media.querySelector('.srv-badge:not(.srv-badge--sale):not(.srv-badge--set)');
      if (best) { best.after(b); b.classList.add('is-second'); } else media.appendChild(b);
    }
    const open = card.querySelector('[data-quick-open]');
    if (open && !isSet) open.textContent = '+ Quick add';
  });

  const camera = () => document.querySelectorAll('[data-cam]').forEach((cam) => {
    if (cam.dataset.styled) return; cam.dataset.styled = '1';
    const section = cam.closest('section');
    const head = section && section.querySelector('.srv-script');
    if (head) {
      head.textContent = 'served on you';
      const sub = document.createElement('p');
      sub.className = 'srv-cam__sub';
      sub.textContent = 'Real girls, real fits. Tag @served.eg to be featured.';
      head.after(sub);
    }
    cam.classList.add('srv-cam--pink');
    const body = cam.querySelector('.srv-cam__body');
    const btn = cam.querySelector('[data-cam-next]');
    const shots = [...cam.querySelectorAll('[data-shot]')];
    const side = document.createElement('div');
    side.className = 'srv-cam__side';
    side.innerHTML = '<span class="srv-cam__brand">Served</span>';
    side.appendChild(btn);
    const dots = document.createElement('div');
    dots.className = 'srv-cam__dots';
    shots.forEach(() => dots.appendChild(document.createElement('i')));
    side.appendChild(dots);
    body.appendChild(side);
    const strap = document.createElement('span'); strap.className = 'srv-cam__strap'; cam.prepend(strap);
    const bump = document.createElement('span'); bump.className = 'srv-cam__bump'; body.prepend(bump);
    const bar = cam.querySelector('.srv-cam__bar'); if (bar) bar.remove();
    const top = cam.querySelector('.srv-cam__top'); if (top) top.remove();
    const sync = () => { const i = shots.findIndex((s) => s.classList.contains('is-on')); [...dots.children].forEach((d, k) => d.classList.toggle('is-on', k === i)); };
    shots.forEach((s) => new MutationObserver(sync).observe(s, { attributes: true, attributeFilter: ['class'] }));
    sync();
    const hint = document.createElement('p');
    hint.className = 'srv-cam__hint';
    hint.textContent = 'tap the button to flick through ✦';
    cam.after(hint);
    const follow = document.createElement('a');
    follow.className = 'srv-cam__follow';
    follow.href = 'https://www.instagram.com/served.eg/';
    follow.target = '_blank'; follow.rel = 'noopener';
    follow.textContent = 'Follow @served.eg';
    hint.after(follow);
  });

  /* product page: tag row (Bestseller + stock wording, never a number) and size buttons with weight guide */
  const WEIGHT = { 'S–M': 'up to 65 kg', 'M–L': 'up to 75 kg' };
  const LAST_FEW = 5; // 1-5 left -> 'Last few', 6+ -> 'Limited stock' (every in-stock size gets a tag)
  const stockText = (q, size) => {
    if (!(q > 0)) return '';
    const where = size ? ' in ' + size : '';
    return (q <= LAST_FEW ? 'Last few' : 'Limited stock') + where;
  };
  const product = () => document.querySelectorAll('.srvp[data-srvp]').forEach((root) => {
    if (root.dataset.tagged) return; root.dataset.tagged = '1';
    const title = root.querySelector('.srvp__title');
    if (!title) return;
    const row = document.createElement('div');
    row.className = 'srvp__tags';
    const isBest = [...root.querySelectorAll('.srvp__badge')].some((b) => /bestseller/i.test(b.textContent));
    if (isBest) { const t = document.createElement('span'); t.className = 'srvp__tag srvp__tag--best'; t.textContent = 'Bestseller'; row.appendChild(t); }
    const stock = document.createElement('span'); stock.className = 'srvp__tag srvp__tag--stock'; stock.hidden = true; row.appendChild(stock);
    title.before(row);
    const sizes = [...root.querySelectorAll('.srvp__size')];
    sizes.forEach((b) => {
      const label = b.textContent.trim();
      b.innerHTML = '';
      const l = document.createElement('b'); l.textContent = label; b.appendChild(l);
      if (WEIGHT[label]) { const w = document.createElement('small'); w.textContent = WEIGHT[label]; b.appendChild(w); b.classList.add('has-guide'); }
      b.dataset.label = label;
    });
    const single = document.querySelector('[data-srv-stock]');
    const update = () => {
      let txt = '';
      if (sizes.length) {
        const b = root.querySelector('.srvp__size.is-on') || sizes[0];
        if (b && b.dataset.tracked) txt = stockText(+b.dataset.qty, b.dataset.label);
      } else if (single && single.dataset.tracked) {
        txt = stockText(+single.dataset.srvStock, '');
      }
      stock.textContent = txt; stock.hidden = !txt;
      stock.classList.toggle('is-urgent', /^Last few/.test(txt));
      row.classList.toggle('is-empty', !isBest && !txt);
    };
    sizes.forEach((b) => b.addEventListener('click', () => setTimeout(update, 0)));
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update); else update();
    if (sizes.length) root.classList.add('srvp--guided');
  });

  const run = () => { cards(); camera(); product(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
